// Module
var code = "<div layout=\"row\" layout-align=\"start center\"> <md-radio-button flex class=\"\" ng-disabled=\"!!$ctrl.isExcluded\" ng-value=\"$ctrl.id\"> <bringoz-package-item id=\"$ctrl.id\"></bringoz-package-item> </md-radio-button> </div> ";
// Exports
export default code;